import { CuentaAutocompleteComponent } from '../../common/autocomplete/cuenta-autocomplete';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CuentasService } from '../../../services/cuentas-service';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-new-contacto-dialog',
  templateUrl: './new-contacto-dialog.component.html',
  styleUrls: ['./new-contacto-dialog.component.scss']
})
export class NewContactoDialogComponent implements OnInit {
  @ViewChild("cellphoneNumberRef") cellphoneNumberRef;
  @ViewChild("phoneNumberRef") phoneNumberRef;
  @ViewChild("emailRef") emailRef;

  @ViewChild(CuentaAutocompleteComponent) cuentaAutocompleteComponent;  
  public contacto;

  public title: string;
  public positiveText: string;
  public negativeText: string;

  public fullName: string;
  public role: string;
  public phoneNumber: string;
  public email: string;
  public cuentaId: string;
  public address: string;
  public cellphoneNumber: string;
  public primaryContact: boolean;

  public cuentaFullName: string;

  public noEmpresa: boolean = false;

  constructor(private cuentasService: CuentasService,
              public dialogRef: MdDialogRef<NewContactoDialogComponent>) { }

  ngOnInit() {

    let { contacto } = this;

    console.log(contacto);

    if (contacto){
      this.cuentaId = contacto.ClienteId;
      this.cuentasService.getContacto(contacto.ClientContactId).subscribe(c => {
        this.fullName = c.FullName;
        this.role = c.Puesto;
        this.phoneNumber = c.Telefono;
        this.email = c.Email;
        this.cellphoneNumber = c.Movil;
        this.address = c.Domicilio;
        this.primaryContact = c.Principal;
      });
      this.cuentasService.getCuenta(contacto.ClienteId).subscribe(c => {
        this.cuentaFullName = c.FullName;
      });
    } else if (this.cuentaId) {
      this.cuentasService.getCuenta(this.cuentaId).subscribe(c => {
        this.cuentaFullName = c.FullName;
      });
    }
  }

  onSubmit(){
    this.noEmpresa = this.cuentaAutocompleteComponent && this.cuentaAutocompleteComponent.selectedCuentas.length <= 0;

    if (this.contacto){
      this.cuentasService.updateContacto(
        this.cuentaId ? this.cuentaId : this.cuentaAutocompleteComponent.selectedCuentas[0].Id,
        this.contacto.ClientContactId,
        this.fullName,
        this.role,
        this.phoneNumber,
        this.email,
        this.address,
        this.cellphoneNumber,
        this.primaryContact
      ).subscribe(
        data => {
          this.dialogRef.close();
        });
    } else if (this.cuentaId || this.cuentaAutocompleteComponent.selectedCuentas.length > 0) {
      this.cuentasService.addContactoToCuenta(
        this.cuentaId ? this.cuentaId : this.cuentaAutocompleteComponent.selectedCuentas[0].Id,
        this.fullName,
        this.role,
        this.phoneNumber,
        this.email,
        this.address,
        this.cellphoneNumber,
        this.primaryContact
      ).subscribe(
        data => {
          this.dialogRef.close();
        });
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/new-contacto-dialog/new-contacto-dialog.component.ts